import { useMemo } from 'react';
import { IDatasetBrief } from '../types/metadata';
import useDatasetStore from '../store/datasetStore';

export const useIsFwe = (datasetId?: string) => {
  const datasetBriefs = useDatasetStore((state) => state.datasetBriefs);

  return useMemo(() => {
    if (!datasetId) return false;

    const brief = datasetBriefs.find(
      (brief: IDatasetBrief) => brief.Id === datasetId
    );

    return brief?.IsFWE;
  }, [datasetId, datasetBriefs]);
};
